module.exports = __webpack_public_path__ + "static/img/边框4.b956598.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/decorativePainting/imgs/边框4.svg
// module id = mwXf
// module chunks = 2